<div class="about-dialog-container">
  <div class="content-left">
    <img src="assets/images/general/arm_about.svg" class="logo">
  </div>
  <div class="content-right">
    <h3>
      AudioCodes Routing Manager
    </h3>
    <div>Product Version: {{productVersion}}</div>
    <div>
                <span>Copyright(C) 1993-{{date | date:'yyyy'}}
                  <a href="http://www.audiocodes.com" target="_blank">Audiocodes Inc.</a>
                </span>
    </div>
  </div>
</div>
